import { makeStyles } from '@mui/styles';

const useAddTraitModalStyle = makeStyles({
  modalPaper: {
    minWidth: 600,
    minHeight: 300,
  },
});

export default useAddTraitModalStyle;
